module.exports = __webpack_public_path__ + "img/pci-dss-compliant-logo-vector.80b1c13c.svg";